<script>
    import Label from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/Label.svelte?1733898724642';
    import { strip_tags } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/sanitize.js?1733898724642';
    import { createEventDispatcher } from 'svelte';
    import Field from '/srv/web/wyvr/html/releases/58819/gen/client/shop/facet/block/Field.svelte?1733898724642';
    import Checkbox from '/srv/web/wyvr/html/releases/58819/gen/client/form/Checkbox.svelte?1733898724642';

    const dispatch = createEventDispatcher();

    export let open = false;
    export let name = '';
    export let value = undefined;
    export let headline;
    export let list;
    export let min = 2;

    let real_values = {};
    let details = {};
    let timer;
    $: closed = list?.slice(0, 5) ?? [];
    let showmore = false;
    let allChecked = true;
    let initialized = false;

    $: update_real_values(value);
    $: if (!open) {
        update();
    }

    function handleAllChange(event) {
        allChecked = event.target.checked;
        Object.keys(real_values).forEach((key) => {
            real_values[key] = false;
        });
        //update();
    }

    function handleCheckboxChange(event, entryValue) {
        allChecked = false; // 'Alle' Checkbox deaktivieren
        real_values[entryValue] = event.target.checked;
        // update();
    }
    function update() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            const data = {};
            let set = false;
            Object.keys(real_values).forEach((key) => {
                if (real_values[key]) {
                    set = true;
                    data[key] = true;
                }
            });
            if (!set) {
                value = undefined;
                details = {};
                dispatch('details', details);
                return;
            }
            value = data;
            details = {};
            const keys = Object.keys(data);
            list.forEach((entry) => {
                if (keys.indexOf(entry.value) > -1) {
                    details[entry.value] = entry;
                }
            });
            dispatch('details', { key: name, details });
        }, 100);
    }

    function update_real_values(value) {
        if (value == undefined) {
            real_values = {};
            return;
        }
        // when the facet gets initialized allow setting the value from outside, afterwards its forbidden
        if(!initialized) {
            initialized = true;
            real_values = value;
        }
    }
</script>

{#if list.length >= min}
    <Field {headline} bind:open>
        <div class="input">
            <div class="m-input m-input--checkbox">
                <Label text="Alle" id="{headline}_select_all">
                    <input
                        type="checkbox"
                        id="{headline}_select_all"
                        bind:checked={allChecked}
                        on:change={handleAllChange}
                    /> <span class="m-input__trigger ri-check-line" />
                </Label>
            </div>
        </div>
        {#if showmore}
            {#each list as entry, i}
                <div class="input">
                    <div class="m-input m-input--checkbox">
                        <Label id="{name}_{entry.value}" text={strip_tags(entry.key)} total={entry.skus.length}>
                            <input
                                type="checkbox"
                                bind:checked={real_values[entry.value]}
                                {name}
                                id="{name}_{entry.value}"
                                value={entry.value}
                                on:change={(e) => {
                                    handleCheckboxChange(e, entry.value);
                                }}
                            /> <span class="m-input__trigger ri-check-line" />
                        </Label>
                    </div>
                </div>
            {/each}
        {:else}
            {#each closed as entry, i}
                <div class="input">
                    <div class="m-input m-input--checkbox">
                        <Label id="{name}_{entry.value}" text={strip_tags(entry.key)} total={entry.skus.length}>
                            <input
                                type="checkbox"
                                bind:checked={real_values[entry.value]}
                                {name}
                                id="{name}_{entry.value}"
                                value={entry.value}
                                on:change={(e) => {
                                    handleCheckboxChange(e, entry.value);
                                }}
                            /> <span class="m-input__trigger ri-check-line" />
                        </Label>
                    </div>
                </div>
            {/each}
        {/if}

        {#if list.length > 5}
            <div class="button">
                <button class="more_loader btn btn--ghost btn--small" on:click={() => (showmore = !showmore)}>
                    {showmore ? window.__('facet.show_less') : window.__('facet.load_more')}
                </button>
            </div>
        {/if}
    </Field>
{/if}


<style>
    .more_loader {
        text-align: center;
    }
    .button {
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 0.6rem;
    }
    :global(label) {
        font-size: 0.875rem !important;
    }
</style>